var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.iconComponent)?_c('font-awesome-icon',_vm._b({attrs:{"icon":_vm.iconComponent}},'font-awesome-icon',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }